import { render, staticRenderFns } from "./AppScoresNCAAFStatistics.vue?vue&type=template&id=78548651&"
import script from "./AppScoresNCAAFStatistics.vue?vue&type=script&lang=js&"
export * from "./AppScoresNCAAFStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports